import { captureError } from '@smg-real-estate/browser-rum';

import * as ToplistingApiService from '@/api/toplistingService';
import { useAgencyStore } from '@/stores/agency/useAgencyStore';
import type { RegionalHighlightSlotsResponse } from '@/types/regionalHighlight';

/**
 * Listing-keyed slots GET. Missing agency/listing is not a transport failure.
 * API errors are captured and rethrown so callers can retry instead of
 * treating the listing as unresolved.
 */
export const peekRegionalHighlightSlotsForListing = async (
  listingId: string,
): Promise<RegionalHighlightSlotsResponse | undefined> => {
  const activeAgencyId = useAgencyStore().activeAgencyId;
  if (!activeAgencyId || !listingId.trim()) {
    return undefined;
  }

  try {
    return await ToplistingApiService.fetchRegionalHighlightSlots(activeAgencyId, listingId);
  } catch (error) {
    captureError(error);
    throw error;
  }
};
